import { Button } from '@/components/Button';
import { Sheet } from '@/components/Sheet';

interface ConfirmSheetProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel?: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** App-owned confirm dialog: never the browser's native confirm(). */
export function ConfirmSheet({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  danger,
  loading,
  onConfirm,
  onClose,
}: ConfirmSheetProps) {
  if (!open) return null;

  return (
    <Sheet title={title} onClose={onClose}>
      <div className="flex flex-col gap-4 p-4">
        <p className="text-body text-text-secondary">{body}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            Keep going
          </Button>
          <Button
            variant={danger ? 'danger' : 'primary'}
            loading={loading}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
